import Logo from "../../assets/newLogo2.png";
import styles from "./styles/style.module.css";
import { Link } from "react-router-dom";

function SiginAndSignUpWrapper({ children, title, step, reset }) {
  return (
    <div className={styles.parent}>
      <Link to="/">
        <img
          src={Logo}
          alt="logo"
          height={40}
          width={140}
          className={styles.logo}
        />
      </Link>
      <div className={styles.signInBox}>
        {step !== 1 && (
          <>
            <div
              className={
                title !== "Forgot your password?" ? styles.headerBox : "null"
              }
            >
              <h2 style={{ marginBottom: "0.5rem" }}>{title}</h2>
            </div>
            {!reset && (
              <>
                {/* <div className={styles.loginWith}>
                  {iconList?.map((item, index) => (
                    <div
                      className={styles.iconBox}
                      key={index}
                      onClick={() =>
                        item === GoogleIcon
                          ? loginWith(1)
                          : item === MicroSoftIcon
                          ? loginWith(2)
                          : loginWith(3)
                      }
                    >
                      <img src={item} alt="icon" height={30} width={30} />
                    </div>
                  ))}
                </div> */}
                {/* <div className={styles.divider}>
                  <Divider style={{ width: "46%" }} />
                  <span className={styles.orText}>Or</span>
                  <Divider style={{ width: "46%" }} />
                </div> */}
              </>
            )}
          </>
        )}

        {children}
      </div>
    </div>
  );
}

export default SiginAndSignUpWrapper;
